/**
 * Product analytics track() — no-op until PostHog is initialized.
 * Props: ids and counts only (no amounts, no names).
 */
import { captureEvent, isPosthogReady } from './posthog'

export type TrackProps = Record<string, string | number | boolean | null | undefined>

export function track(event: string, props?: TrackProps): void {
  if (!isPosthogReady()) return
  captureEvent(event, props)
}
